import {
  type getFrontRichiesteIdModuloIdDocumentoConsolidato,
  getGetFrontRichiesteIdModuloIdDocumentoConsolidatoQueryOptions,
} from '@framework/api-client/api/inquiries-compile/richiesta-moduli/richiesta-moduli.ts';
import {
  type apiClientRequest,
  type ErrorType,
} from '@framework/api-client/client/apiClient.ts';
import { type UseQueryOptions } from 'react-query';
import { type SecondParameter } from './getDocumentoConsolidatoWithoutParamsQueryOptions.ts';

/**
 * Funzione per richiamare il download con omissis true
 */
export function getDocumentoConsolidatoOmissisQueryOptions<
  TData = Awaited<
    ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoConsolidato>
  >,
  TError = ErrorType<unknown>,
>(
  idRichiesta: string,
  idRichiestaModulo: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<
        ReturnType<typeof getFrontRichiesteIdModuloIdDocumentoConsolidato>
      >,
      TError,
      TData
    >;
    request?: SecondParameter<typeof apiClientRequest>;
  },
) {
  return getGetFrontRichiesteIdModuloIdDocumentoConsolidatoQueryOptions(
    idRichiesta,
    idRichiestaModulo,
    { omissis: true },
    options,
  );
}
